<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('coupon.discountCode')" center width="400px"
    :close-on-click-modal="false" @close="whenDialogClose" :show-close="true">
    <!-- <div class="dialog-con df-l-c-fs wh100p" v-loading.lock="el_loading_coupon_select_x"> -->
    <div class="dialog-con df-l-c-fs wh100p">
      <div class="dialog-ctr w100p pb80">

        <Coupon v-for="(x2,i2) in coupons" :key="i2" :coupon="x2" @select="couponSelected" />

      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submitDialog">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import Coupon from './Coupon'
export default {
  name: 'DialogCouponSelect',
  components: { Coupon },
  data() {
    return {
      isShowDialog: false,
      coupons: [], // 所有 = 勾选的 + 未勾选的
      list: [], // 勾选的 = 提交过的 + 未提交的
      // list_: [], // 提交过的
    }
  },
  computed: {
    ...mapState(['el_loading_coupon_select_x']),
  },
  methods: {
    open(coupons) {
      // console.log(`%ccoupons:`, 'color: #f00;', coupons)
      this.coupons = coupons
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.$emit('close')
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.coupons = []
      this.list = []
    },
    
    // 对话框 提交
    submitDialog() {
      const list = []
      // 过滤出未提交过的
      this.list.forEach(x1 => {
        const ITEM = this.coupons.find(x2 => x2.code === x1)
        if (ITEM && ITEM.canUse) {
          list.push(x1)
        }
      })
      this.$emit('submitDialog', {
        type: 'submit',
        list
      })
      this.list_ = JSON.parse(JSON.stringify(this.list))
      this.coupons = []
      this.close()
    },
    couponSelected() {
      // console.log(`%cthis.coupons:`, 'color: #f00;', this.coupons)

      const list = this.coupons.filter(x => x.checked && x.canUse).map(x => x.code)
      // 过滤出勾选的
      list.forEach(x => {
        if (!this.list.includes(x)) {
          this.list.push(x)
        }
      })
      for (let i = 0; i < this.list.length; i++) {
        const x = this.list[i]
        if (!list.includes(x)) {
          this.list.splice(i, 1)
          i--
        }
      }

      this.$emit('select', {
        type: 'select',
        list: this.list
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.dialog-square /deep/.el-dialog{height: 540px;} // 默認500px
/deep/.el-dialog__body{height: calc(100% - 60px);}
</style>